module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/sort-view/sort-view.component.scss
// module id = ./src/app/modules/common-module/components/sort-view/sort-view.component.scss
// module chunks = 9